module.exports = __webpack_public_path__ + "img/stars.dad793f7.png";